import React from 'react';
import { Column } from '@ant-design/plots';

const data = [
	{
		day: 'Mon',
		enrolled: 5
	},
	{
		day: 'Tue',
		enrolled: 13
	},
	{
		day: 'Wed',
		enrolled: 24
	},
	{
		day: 'Thu',
		enrolled: 18
	},
	{
		day: 'Fri',
		enrolled: 8
	},
	{
		day: 'Sat',
		enrolled: 2
	},
	{
		day: 'Sun',
		enrolled: 0
	}
];
const config = {
	data,
	isStack: true,
	xField: 'day',
	yField: 'enrolled',
	// color: '#D9D3FD',
	label: {
		position: 'middle',
		layout: [
			{
				type: 'interval-adjust-position',
			},
			{
				type: 'interval-hide-overlap',
			},
			{
				type: 'adjust-color',
			},
		],
	},
	meta: {
		day: {
			alias: 'Days',
		},
		enrolled: {
			alias: 'Enrolled',
		},
	},
};

export default function PlotColumn() {
  return (
		<div className="PlotColumn">
			<Column {...config} />
		</div>
  )
}